import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import React, { Fragment } from "react";
import { FilterByName, FilterByOrg, FilterByType } from "../controls";
import { GRID_ROWS_PER_PAGE_OPTIONS } from "../../../../constants";
import ListContainer from "../../../list";
import { getI18n } from "../../../../utils/intl";
import { useIntl } from "react-intl";
import styles from '../styles';
import {
  getErrors,
  getIsLoading, getListResults, getListTotalElements, getListTotalPages,
  getOrgSuggestions,
  getRequestUpdateStatus,
} from "../../../../reducers/request";
import { getUserDetails } from "../../../../reducers/portalConfig";
import {
  fetchList,
  fetchOrgSuggestions,
  submitRequest,
} from "../../../../actions/requests";
import { push } from "connected-react-router";
import { arrayOf, bool, func, number, obj, shape, string } from "prop-types";

export const ApplicationRequestsList = (props) => {
  const {
    classes,
    isLoading,
    notificationStatus,
    setNotificationStatus,
    notificationMessage,
    setNotificationMessage,
    onFilterByNameChange,
    filterByName,
    onFilterByNameKeyPress,
    requestTypeOptions,
    onFilterByTypeChange,
    filterByType,
    onFilterByOrgChange,
    onOrgSelection,
    orgSearchText,
    orgSuggestions,
    filterByOrg,
    getListColumns,
    rows,
    page,
    totalElements,
    totalPages,
    rowsPerPage,
    onChangeRowsPerPage,
    onChangePage,
    onChangePreviousPage,
    onChangeNextPage,
    emptyFunction,
  } = props;

  const { getI18nMessage } = getI18n(useIntl());
  return (
    <ListContainer
      listPageId="application-request-list"
      isLoading={isLoading}
      classes={classes}
      notificationId="request-notifications"
      notificationStatus={notificationStatus}
      setNotificationStatus={setNotificationStatus}
      notificationMessage={notificationMessage}
      setNotificationMessage={setNotificationMessage}
      hasNotificationIcon={true}
      addButtonLabel={''}
      onAdd={false}
      showListHeader={true}
      filterAndSortContent={(
        <Fragment>
          <FilterByName
            fieldContainerClass={classes.nameFieldContainer}
            handleChange={onFilterByNameChange}
            name={getI18nMessage('label.filter')}
            onKeyPress={onFilterByNameKeyPress}
            placeholder={getI18nMessage('label.request.name')}
            value={filterByName}
          />
          <FilterByType
            data={requestTypeOptions}
            fieldContainerClass={classes.fieldContainer}
            handleChange={onFilterByTypeChange}
            hideLabel
            name={getI18nMessage('label.filter.by')}
            value={filterByType}
          />
          <FilterByOrg
            fieldContainerClass={classes.fieldContainer}
            filterSelectedOptions={false}
            hideLabel
            name={getI18nMessage('label.filter.by')}
            onInputChange={(event, value) => onFilterByOrgChange(value)}
            onChange={(event, value) => onOrgSelection(value)}
            options={orgSuggestions}
            inputLabel={getI18nMessage('label.request.org')}
            searchText={orgSearchText}
            value={filterByOrg}
          />
        </Fragment>
      )}
      columns={getListColumns({ getI18nMessage, classes })}
      rows={rows}
      noResultsMessage={getI18nMessage('label.request.list.no.results')}
      page={page}
      totalElements={totalElements}
      totalPages={totalPages}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={GRID_ROWS_PER_PAGE_OPTIONS}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onChangePage={onChangePage}
      onChangePreviousPage={onChangePreviousPage}
      onChangeNextPage={onChangeNextPage}
      notifyMessages={emptyFunction}
      pageFilterAndSortClass={classes.pageFilterAndSortClass}
    />
  )
};

ApplicationRequestsList.propTypes = {
  classes: shape({}),
  isLoading: bool,
  notificationStatus: string,
  setNotificationStatus: func,
  notificationMessage: string,
  setNotificationMessage: func,
  onFilterByNameChange: func,
  filterByName: string,
  onFilterByNameKeyPress: func,
  requestTypeOptions: arrayOf(obj),
  onFilterByTypeChange: func,
  filterByType: string,
  onFilterByOrgChange: func,
  onOrgSelection: func,
  orgSearchText: string,
  orgSuggestions: arrayOf(shape({})),
  filterByOrg: string,
  getListColumns: func,
  rows: arrayOf(obj),
  page: number,
  totalElements: number,
  totalPages: number,
  rowsPerPage: number,
  onChangeRowsPerPage: func,
  onChangePage: func,
  onChangePreviousPage: func,
  onChangeNextPage: func,
  emptyFunction: func,
};

ApplicationRequestsList.displayName = 'ApplicationRequests';

const mapStateToProps = (state) => ({
  isLoading: getIsLoading(state),
  orgSuggestions: getOrgSuggestions(state),
  requestUpdateStatus: getRequestUpdateStatus(state),
  results: getListResults(state),
  totalElements: getListTotalElements(state),
  totalPages: getListTotalPages(state),
  user: getUserDetails(state),
  errors: getErrors(state),
});

const mapDispatchToProps = {
  fetchList,
  fetchOrgSuggestions,
  submitRequest,
  push,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(ApplicationRequestsList);
